import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { Component, OnDestroy } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LinkAssetServiceService } from 'app/assets/service/link-asset-service.service';
import { DynamicDrawerService } from 'app/shared/dynamic-drawer.service';

@Component({
  selector: 'app-checkbox-cell',
  templateUrl: './checkbox-cell.component.html',
  styleUrls: ['./checkbox-cell.component.scss']
})

export class CheckboxCellComponent implements ICellRendererAngularComp, OnDestroy {
  readonly destroyed = new ReplaySubject(1);
  public checkState = false;
  private params: ICellRendererParams;
  public disabled = false;

  constructor(readonly drawerService: DynamicDrawerService<any>, readonly linkAssetServiceService: LinkAssetServiceService) { }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.disabled = this.params?.data?.disabled;
    // change checked status for rows
    this.onCheckChange(this.params?.data?.checked);
    this.updateCheckboxState();
  }

  /**
   * selection change event
   * @param checked checked value
   * @param changeEvent change event parameter
   */
  onCheckChange(checked, changeEvent: boolean = false): void {
    this.checkState = checked;
    this.params.data.checked = this.checkState;

    if (changeEvent) {
      // for map location assets
      if ('type' in this.params.data && ('propertyId' in this.params.data)) {
        this.drawerService._selectedLocationAssets.next({ id: this.params.data.id, type: this.params.data.type, propertyId: this.params.data.propertyId, tagId: this.params.data.tagId, componentInstanceId: this.params.data.componentInstanceId, checked: checked, value: this.params.data.value, assetId: this.params.data.assetId })
      } else {
        // for single tag case
        this.drawerService._selectedTagId.next({ id: this.params.data.id, checked: checked, componentInstanceId: this.params.data.componentInstanceId });
      }
    }

    this.params.api.refreshCells(this.params as any);
    if (this.params?.node?.data) {
      if (checked) {
        this.linkAssetServiceService.addCheckedTagValue(this.params.node.data);
      } else {
        this.linkAssetServiceService.removeCheckedTagValue(this.params.node.data);
      }
    }

  }

  /**
   * update checckbox state
   */
  updateCheckboxState() {
    this.linkAssetServiceService.checkedLinkTags$.pipe(takeUntil(this.destroyed))
      .subscribe(linkTagsMap => {
        const id = this.params?.data?.id + '_' + this.params?.data?.componentInstanceId;
        this.checkState = linkTagsMap.has(id);
      });
  }

  refresh(params: any): boolean {
    this.params = params;
    return false;
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }

}